import { Box, BoxProps } from '@chakra-ui/react';

interface Props extends BoxProps {
  children: React.ReactNode;
  bar: React.ReactNode;
}

export function TopRightContainerComponent({ children, bar, ...props }: Props) {
  return (
    <Box pos="relative" {...props}>
      {children}
      {bar && (
        <Box pos="absolute" right={-2} top={-3}>
          {bar}
        </Box>
      )}
    </Box>
  );
}
